import {
	InsightCallout,
	type InsightCalloutProps,
} from "../DataCards/InsightCallout";

type Props = Pick<
	InsightCalloutProps,
	| "text"
	| "isLoading"
	| "variant"
	| "onActionPress"
	| "actionLabel"
	| "expandable"
> & {
	isError?: boolean;
};

export const TipCallout = ({
	text,
	isLoading = false,
	isError = false,
	variant = "flat",
	onActionPress,
	actionLabel,
	expandable,
}: Props) => {
	if (isError) {
		return null;
	}

	if (!isLoading && !text?.trim()) {
		return null;
	}

	return (
		<InsightCallout
			text={text}
			isLoading={isLoading}
			variant={variant}
			onActionPress={onActionPress}
			actionLabel={actionLabel}
			expandable={expandable}
		/>
	);
};
